<template>
    <div class="d-inline-block">
        <v-dialog v-model="dialog" width="500" :disabled="!hasPermission('menu_schema_export')">
            <template #activator="{ on }">
                <icon-button
                        v-on="on"
                        icon="save"
                        color="amber darken-1"
                        cls="mr-0 ml-0"
                        permission="menu_schema_export"
                        :tooltip="{ bottom: true, attach: true}"
                >
                    {{ 'app.save_as_schema' | trans}}
                </icon-button>
            </template>
            <v-card class="bg-whitesmoke">
                <v-card-title class="grey lighten-2" primary-title>
                    <h3 class="headline mb-0 mt-0">
                        {{'app.save_as_schema' | trans}}
                    </h3>
                </v-card-title>
                <v-card-text>
                    <v-form ref="form" v-model="valid" lazy-validation>
                        <v-container grid-list-md>
                            <v-layout row wrap>
                                <v-flex xs12>
                                    <v-text-field :error-messages="titleError"
                                                  v-model="model.title"
                                                  :rules="rules.title" required
                                                  :label="trans('app.name')"
                                                  solo
                                                  @input="debounceValidateName">

                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12 d-flex>
                                    <v-combobox
                                            multiple
                                            clearable
                                            v-model="dietsTags"
                                            :search-input.sync="syncDiet"
                                            :items="dietsItems"
                                            item-text="name"
                                            solo
                                            :label="trans('page.tags.diet')"
                                    >
                                        <template v-slot:no-data>
                                            <v-list-tile>
                                                <v-list-tile-content>
                                                    <v-list-tile-title>
                                                        <span v-if="dietsItems.length > 0"
                                                              v-html="trans('app.no_tag', {type: 'dieta', tag: syncDiet})"></span>
                                                        <span v-else
                                                              v-html="trans('app.tag_collection_empty', {type: 'dieta', tag: syncDiet})"></span>
                                                    </v-list-tile-title>
                                                </v-list-tile-content>
                                            </v-list-tile>
                                        </template>
                                    </v-combobox>
                                </v-flex>
                                <v-flex xs12 d-flex>
                                    <v-combobox
                                            multiple
                                            clearable
                                            v-model="schemasTags"
                                            :search-input.sync="syncSchemas"
                                            :items="schemasItems"
                                            item-text="name"
                                            solo
                                            :label="trans('page.tags.tag')"
                                    >
                                        <template v-slot:no-data>
                                            <v-list-tile>
                                                <v-list-tile-content>
                                                    <v-list-tile-title>
                                                        <span v-if="schemasItems.length > 0"
                                                              v-html="trans('app.no_tag', {type: 'schema', tag: syncSchemas})"></span>
                                                        <span v-else
                                                              v-html="trans('app.tag_collection_empty', {type: 'schema', tag: syncSchemas})"></span>
                                                    </v-list-tile-title>
                                                </v-list-tile-content>
                                            </v-list-tile>
                                        </template>
                                    </v-combobox>
                                </v-flex>
                                <v-flex xs6 d-flex v-if="hasPermission('create_system_schema')">
                                    <v-checkbox
                                            v-model="model.system"
                                            :label="trans('app.system')"
                                    ></v-checkbox>
                                </v-flex>
                                <v-flex xs6 d-flex>
                                    <v-checkbox
                                            v-model="model.favorited"
                                            required
                                            :label="trans('app.favorited')"
                                            color="primary"
                                    ></v-checkbox>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" flat @click="close">
                        {{ 'app.close' | trans }}
                    </v-btn>
                    <v-btn color="primary" @click="store" :disabled="storeButtonDisabled" :loading="loading">
                        {{ 'app.save' | trans }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </div>
</template>

<script>
    import {debounce} from 'lodash';
    import {mapGetters, mapState} from 'vuex';
    import {trans} from '../app';
    import {ErrorsBag} from '../utils/ErrorsBag';

    export default {
    props: ['id'],
    data: () => ({
        syncDiet: '',
        syncSchemas: '',
        dialog: false,
        loading: false,
        model: {
          title: null,
          tags: [],
        },
        titleError: [],
        rules: {
          title: [
            v => !!v || trans('validation.required', { 'attribute': trans('app.name') }),
            v => v && v.length <= 255 || trans('validation.max.string', {
              attribute: trans('app.name'),
              max: 255,
            }),
            v => v && v.length >= 4 || trans('validation.min.string', {
              attribute: trans('app.name'),
              min: 4,
            }),
          ],
        },
        valid: false,
        errors: null,
      }
    ),

    created() {
      this.errors = new ErrorsBag();
      this.titleError = [];
      this.debounceValidateName = debounce(this.validateName, 200);
    },

    computed: {
      ...mapState(['dictionaries', 'menu']),
      ...mapGetters(['hasPermission']),
      schemasItems() {
        return [...this.dictionaries.schemas, ...this.schemasTags];
      },
      dietsItems() {
        return [...this.dictionaries.diets, ...this.dietsTags];
      },
      schemasTags: {
        get() {
          return this.getTags('schema');
        },
        set(tags) {
          this.setTags(tags, 'schema');
        },
      },

      dietsTags: {
        get() {
          return this.getTags('diet');
        },
        set(tags) {
          this.setTags(tags, 'diet');
        },
      },
      method() {
        return 'POST';
      },
      endpoint() {
        return `/menus/${this.id}/exports`;
      },
      storeButtonDisabled() {
          return !this.valid || typeof this.model === 'undefined' || !this.model.title || this.model.title.length === 0;
      }
    },

    methods: {
      open() {
        this.dialog = true;
      },

      async store() {
        this.loading = true;
        try {
          await axios({
            url: this.endpoint,
            method: this.method,
            data: this.model,
          });

            this.$toast.success(trans('app.actions.saved', {name: trans('app.schema').toLowerCase()}));
            this.close();

        } catch (error) {
            if (error.response && error.response.status === 422) {
                this.errors.record(error.response.data.errors);
            } else {
                this.sentryCaptureException(error);
            }
        }

        this.loading = false;
      },

      async validateName() {
        if (!this.model.title) {
          return true;
        }

        const { data } = await axios.get(`/schemas/data?title=${this.model.title}`);

        if (data.meta.total === 0 || data.data[0].id === this.model.id) {
          this.titleError = [];
          return;
        }

        this.titleError.push(trans('validation.unique', { 'attribute': trans('app.title') }));
      },
      getTags(type) {
        return this.model.tags && this.model.tags.length > 0 ? this.model.tags.filter(t => t.type === type) : [];
      },
      setTags(tags, type) {
        tags.forEach((value, index) => {
          if (typeof value === 'string')
            tags[index] = {
              name: value,
              type,
              id: null,
            };
        });

        this.model.tags = this.model.tags.filter(t => t.type !== type);
        this.model.tags.push(...tags);
      },

      close() {
        this.dialog = false;
        setTimeout(() => {
          this.model = {
            tags: [],
            title: null,
          };
          this.errors.clear();
          this.titleError = [];
          this.$emit('close');
        }, 100);
      },
    },
  };
</script>
